"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconPaymentFill', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M1 4C1 3.44772 1.44772 3 2 3H14C14.5523 3 15 3.44772 15 4V12C15 12.5523 14.5523 13 14 13H2C1.44772 13 1 12.5523 1 12V4ZM13 6H3V5L13 5V6Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M2 3.99994C1.44772 3.99994 1 4.44765 1 4.99994L1 7.99829L1 7.99994L1 8.00159L1 14.9999C1 15.5522 1.44772 15.9999 2 15.9999L18 15.9999C18.5523 15.9999 19 15.5522 19 14.9999V4.99994C19 4.44765 18.5523 3.99994 18 3.99994L2 3.99994ZM17 5.99994V6.99994L3 6.99994L3 5.99994L17 5.99994ZM12 10.9999C11.4477 10.9999 11 11.4477 11 11.9999C11 12.5522 11.4477 12.9999 12 12.9999H15C15.5523 12.9999 16 12.5522 16 11.9999C16 11.4477 15.5523 10.9999 15 10.9999L12 10.9999Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M2 4C1.44772 4 1 4.44771 1 5L1 19C1 19.5523 1.44772 20 2 20L22 20C22.5523 20 23 19.5523 23 19L23 5C23 4.44771 22.5523 4 22 4L2 4ZM21 6V8L3 8L3 6L21 6ZM15 15C14.4477 15 14 15.4477 14 16C14 16.5523 14.4477 17 15 17H19C19.5523 17 20 16.5523 20 16C20 15.4477 19.5523 15 19 15H15Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M2.49994 6.00006C2.10211 6.00006 1.72058 6.1581 1.43928 6.4394C1.15797 6.72071 0.999939 7.10224 0.999939 7.50006L0.999939 25.5001C0.999939 26.3285 1.67151 27.0001 2.49994 27.0001L29.4999 27.0001C30.3284 27.0001 30.9999 26.3285 30.9999 25.5001L30.9999 7.50006C30.9999 6.67163 30.3284 6.00006 29.4999 6.00006L2.49994 6.00006ZM3.99994 9.00006L3.99994 11.0001L27.9999 11.0001V9.00006H3.99994ZM22.5002 23.0001H25.5002C26.3286 23.0001 27.0002 22.3285 27.0002 21.5001C27.0002 20.6716 26.3286 20.0001 25.5002 20.0001H22.5002C21.6718 20.0001 21.0002 20.6716 21.0002 21.5001C21.0002 22.3285 21.6718 23.0001 22.5002 23.0001Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;